import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import EditRatingModel from "../../../../models/admin/interviews/response/EditRatingModel";
import EditRatingSearchInputModel from "../../../../models/admin/interviews/request/EditRatingSearchInputModel";
import adminInterviewsService from "../../../../services/admin/admin-interviews-service";
import toasterUtils from "../../../../utils/toaster-utils";
import EditRatingGridComponent from "./EditRatingGridComponent";
import EditRatingPopUp from "./EditRatingUpdateComponent";
import { GeneralPoupConfig, ModalSize } from "../../../../models/modal-types";
import modalUtils from "../../../../utils/modal-utils";
import InterviewRatingModel from "../../../../models/interviewer/response/InterviewRatingModel";
import { TextField, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const EditRatingComponent = () => {
    const history = useHistory();
    const [interviewsList, setInterviewsList] = useState<EditRatingModel[]>([]);
    const [refreshInterviews, setRefreshInterviews] = useState<number>(2);
    const [candidateNameSearch, setCandidateNameSearch] = useState<string>("");
    const [interviewUniqueIdSearch, setInterviewUniqueIdSearch] = useState<string>("");

    useEffect(() => {
        clearSearch();
    }, []);

    const clearSearch = () => {
        setInterviewsList([]);
        setCandidateNameSearch("");
        setInterviewUniqueIdSearch("");
        setRefreshInterviews(2);
    };

    const getInterviews = () => {
        setRefreshInterviews(2);
        var inputData: EditRatingSearchInputModel = {
            candidateName: candidateNameSearch,
            interviewUniqueId: interviewUniqueIdSearch
        };
        modalUtils.showLoader();
        adminInterviewsService.getInterviewsForRatingEdit(inputData).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setInterviewsList([]);
            setInterviewsList(res.items);
            setRefreshInterviews(refreshInterviews * 5);
        }).catch((error) => {
            setRefreshInterviews(refreshInterviews * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onRatingEditActionHandler = (interviewId: string) => {
        modalUtils.showLoader();
        adminInterviewsService.getInterviewRatingDetails(interviewId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            if (res.isSuccess) {
                const config: GeneralPoupConfig = {
                    title: "Add User",
                    content: (
                        <EditRatingPopUp
                            objRateInterview={res.data}
                            onRatingUpdateAction={onRatingUpdateActionHandler}
                            onRatingClearAction={onRatingClearActionHandler}
                        />
                    ),
                    size: ModalSize.XL,
                    className: "model-min-height-500"
                };
                modalUtils.showPopup(config);
            } else {
                toasterUtils.showError(res.errorMessages.toString());
            }
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Schedules");
        });
    };

    const onRatingClearActionHandler = () => {
        modalUtils.closeModal();
    };

    const onRatingUpdateActionHandler = (objRateInterview: InterviewRatingModel) => {
        modalUtils.showLoader();
        adminInterviewsService.updateInterviewRating(objRateInterview).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getInterviews();
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onSetInterviewEditModeHandler = (interviewId: string) => {
        modalUtils.showLoader();
        adminInterviewsService.setInterviewUpdateMode(interviewId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getInterviews();
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <TextField label="Candidate Name" size="small" margin="normal" fullWidth variant="outlined" onChange={(e) => setCandidateNameSearch(e.target.value)} placeholder="Name Like" autoComplete="off" />
                    </div>
                    <div className="col-md-3">
                        <TextField label="Interview Id" size="small" margin="normal" fullWidth variant="outlined" onChange={(e) => setInterviewUniqueIdSearch(e.target.value)} placeholder="Interview Id" autoComplete="off" />
                    </div>
                    <div className="col-md-3">
                        <Button variant="contained" color="success" onClick={() => getInterviews()} startIcon={<SearchIcon />} sx={{ ml: 2, mt: 2 }}>
                            Search
                        </Button>
                        <Button variant="contained" color="warning" onClick={() => clearSearch()} startIcon={<ClearIcon />} sx={{ ml: 2, mt: 2 }}>
                            Clear
                        </Button>
                    </div>
                </div>
                {interviewsList.length > 0 && refreshInterviews > 2 &&
                    <EditRatingGridComponent
                        key={refreshInterviews}
                        interviewList={interviewsList}
                        onRatingEditAction={onRatingEditActionHandler}
                        onSetInterviewEditModeAction={onSetInterviewEditModeHandler} />
                }
            </div>
        </div>
    );
};
export default EditRatingComponent;